import { render } from "./WindowsIcon.vue?vue&type=template&id=8ef94e9c"
const script = {}
script.render = render

export default script